/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { copyToClipboard } from "config/Utilities";
import { TextInput, View, TouchableOpacity } from "react-native";
import Icon from "react-icons-kit";
import { ic_check } from "react-icons-kit/md/ic_check";
import { closeRound } from "react-icons-kit/ionicons/closeRound";

import Rodal from "rodal";
import "rodal/lib/rodal.css";
import { Button, Text } from "UpduoLibrary";
import {
  skaleGray,
  skaleBlack,
  skalePrimaryBlue,
  skaleWhite,
} from "config/UpduoColors";

interface GenerateShareLinkModalProps {
  inviteUuid: string | null;
  onClose: () => void;
  isVisible: boolean;
}

export default function GenerateShareLinkModal({
  inviteUuid,
  onClose,
  isVisible,
}: GenerateShareLinkModalProps) {
  const [copySuccess, setCopySuccess] = useState(false);

  const _onPress = () => {
    copyToClipboard(`${process.env.PUBLIC_URL}/#/event/rsvp/${inviteUuid}`);
    setCopySuccess(true);
  };

  if (!inviteUuid) {
    return null;
  } else
    return (
      <Rodal
        visible={isVisible}
        customStyles={{
          height: 280,
          width: 400,
          borderRadius: 12,
        }}
        onClose={() => {
          setCopySuccess(false);
          onClose();
        }}
      >
        <View
          style={{
            flex: 1,
            height: "100%",
          }}
        >
          <View
            style={{
              alignSelf: "flex-end",
              justifyContent: "flex-end",
            }}
          >
            <TouchableOpacity
              onPress={() => {
                setCopySuccess(false);
                onClose();
              }}
            >
              <Text
                style={{
                  color: skaleBlack,
                }}
              >
                <Icon size={20} icon={closeRound} />
              </Text>
            </TouchableOpacity>
          </View>
          <View
            style={{
              height: "95%",
              alignItems: "center",
              justifyContent: "space-around",
            }}
          >
            <Text isHeading={true} style={{ fontSize: 18 }}>
              {`Get Link`}
            </Text>
            <Text style={{ fontSize: 14, textAlign: "center" }}>
              {"Anyone with this link can view topic and RSVP"}
            </Text>
            <Text style={{ fontSize: 12, textAlign: "center" }}>
              {
                "Please make sure the topic is published before visiting the link."
              }
            </Text>
            <TextInput
              style={{
                width: "100%",
                backgroundColor: skaleGray,
              }}
              value={`${process.env.PUBLIC_URL}/#/event/rsvp/${inviteUuid}`}
            />
            <View
              style={{
                flexDirection: "row",
              }}
            >
              <Button
                onPress={_onPress}
                text={"Copy link"}
                color={skalePrimaryBlue}
                textColor={skaleWhite}
                borderWidth={1}
                borderColor={skalePrimaryBlue}
              />
            </View>
            {copySuccess ? (
              <View
                style={{
                  alignSelf: "center",
                }}
              >
                <Text
                  style={{
                    fontSize: 12,
                    color: "green",
                  }}
                >
                  {"Copied to clipboard!"}
                  <Icon
                    style={{
                      marginLeft: 5,
                      justifyContent: "flex-end",
                      color: "green",
                    }}
                    size={12}
                    icon={ic_check}
                  />
                </Text>
              </View>
            ) : null}
          </View>
        </View>
      </Rodal>
    );
}
